<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import VisitCommunity from 'src/components/main/#common/visit-community/VisitCommunity.svelte'
    import {Link} from 'svelte-routing'
    import IconifyIcon from '@iconify/svelte'
    import twitterIcon from '@iconify/icons-fa-brands/twitter'
    import facebookIcon from '@iconify/icons-fa-brands/facebook-f'
    import learnMore from 'src/components/main/#assets/learn-more.svg'
    import blockquote from 'src/components/main/article/blockquote.svg'
    import {getArticleByUrl, getArticlesByFilter, getPinnedArticle} from 'src/components/main/#services/blogArticles'
    import {userIsAdmin} from 'src/components/main/#services/userRole'
    import {dateFormat} from 'src/global/dateFormat'
    import BlogRelated from 'src/components/main/blog/components/blog-related/BlogRelated.svelte'
    import {isLoggedIn} from 'src/services/auth'

    export let url

    let link
    let shareTwitterLink = 'https://twitter.com/intent/tweet?text=https://realis.network/blog/'+url
    let shareFacebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https://realis.network/blog/'+url

    $: {
        getArticleByUrl.reset()
        getArticleByUrl.send({data: {url}})
        link = location.href
    }

    let article
    $: if ($getArticleByUrl.hasValue) {
        article = $getArticleByUrl.value && JSON.parse(JSON.stringify($getArticleByUrl.value))
    }

    let editLink = ''
    $: if ($userIsAdmin.value && article && process.env.DASHBOARD_URL && $userIsAdmin.value.pages.includes('blog')) {
        editLink = process.env.DASHBOARD_URL + '/blog/article/edit/' + article.id
    }
</script>

<svelte:head>
    {#if article}
        <title>{article.metaTitle}</title>
        <meta name="description" content="{article.metaDescription}"/>
        <meta property="og:title" content="{article.metaTitle}" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="{process.env.BLOG_PATH+article.url}" />
        <meta property="og:image" content="{process.env.IMAGES_PATH+article.image}" />
    {/if}
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <section class="article-section">
            <div class="container">
                <Link to="blog" class="back"><img src="{learnMore}" alt="">Back to Blog</Link>
                {#if !article && (!$getArticleByUrl.hasValue && $getArticleByUrl.loading)}
                    <div class="color-white"><br>Loading...</div>
                {:else if !article && (!$getArticleByUrl.hasValue && $getArticleByUrl.error) }
                    <div class="color-white"><br>Something went wrong. Try refreshing the page.</div>
                {:else if article}
                    <h1 class="title">{article.title}</h1>
                    <div class="date">{dateFormat(article.createdAt, 'full')}
                        {#if editLink}
                            | <a href="{editLink}" class="edit-article-btn" target="_blank">Edit article</a>
                        {/if}
                    </div>
                    <div class="article-content" style="--Blockquote:url({blockquote});">{@html article.content}</div>
                {/if}
                <div class="share">
                    <a href="{shareTwitterLink}" target="_blank" rel="nofollow" class="link">
                        <IconifyIcon icon={twitterIcon}/>
                    </a>
                    <a href="{shareFacebookLink}" target="_blank" rel="nofollow" class="link">
                        <IconifyIcon icon={facebookIcon}/>
                    </a>
                </div>
                {#if article}
                    <BlogRelated articleId="{article.id}" categoryId="{article.category.id}" limit="{3}"/>
                {/if}
            </div>
        </section>
        <!--<VisitCommunity/>-->
    </svelte:fragment>
</MainLayout>

<style>
    .edit-article-btn {
        color: #828282;
        text-decoration: none;
        transition: .25s;
    }

    .edit-article-btn:hover {
        color: #afafaf;
        text-decoration: underline;
    }

    .article-content p {
        margin-bottom: 0;
    }

    .article-section {
        position: relative;
        padding-top: 110px;
    }

    .article-section :global(.back) {
        color: white;
        font-size: 20px;
        font-family: 'Anton', sans-serif;
        margin: 50px 0;
        display: table;
        text-decoration: none;
        text-transform: uppercase;
    }

    .article-section :global(.back img) {
        margin-right: 10px;
        transform: rotate(-90deg);
        transition: .25s;
    }

    .article-section :global(.back:hover img) {
        transform: rotate(-135deg);
    }

    .title {
        font-size: 40px;
        line-height: 60px;
        color: white;
        font-family: 'Anton', sans-serif;
        margin: 50px 0 20px;
    }

    .date {
        color: #828282;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 50px;
    }

    .article-content {
        color: white;
        font-size: 16px;
        line-height: 27px;
        padding-bottom: 80px;
    }

    .article-content :global(img) {
        margin: 50px auto;
        display: block;
        max-width: 100%;
    }

    .article-content :global(img[style="float: left;"]) {
        margin-right: 30px;
    }

    .article-content :global(img[style="float: right;"]) {
        margin-left: 30px;
    }

    .article-content :global(a) {
        color: #1D92FF;
        text-decoration: none;
    }

    .article-content :global(a:hover) {
        color: #1D92FF;
        text-decoration: underline;
    }

    .article-content :global(h2) {
        font-weight: 600;
        font-size: 30px;
        line-height: normal;
        margin: 80px 0 30px;
    }

    .article-content :global(h3) {
        font-weight: 500;
        font-size: 20px;
        line-height: 30px;
        margin: 50px 0 30px;
    }

    .article-content :global(ul) {
        margin: 30px 0;
        padding-left: 70px;
        list-style: none;
    }

    .article-content :global(ul li) {
        position: relative;
        margin-bottom: 20px;
    }

    .article-content :global(ul li:before) {
        content: "";
        width: 10px;
        height: 10px;
        background: #FF5D1C;
        position: absolute;
        left: -22px;
        border-radius: 50%;
        top: 8px;
    }

    .article-content :global(blockquote) {
        background: #282D39;
        border-radius: 5px;
        margin: 78px 220px 50px;
        padding: 22px 70px;
        position: relative;
    }

    .article-content :global(blockquote:before) {
        content: "";
        background: var(--Blockquote) no-repeat center;
        width: 83px;
        height: 62px;
        position: absolute;
        left: -30px;
        top: -28px;
    }

    .article-content :global(blockquote em) {
        color: #E0E0E0;
        margin-top: 10px;
        display: block;
        font-style: italic;
        font-weight: 300;
    }

    .article-content :global(ol) {
        margin: 30px 0;
        padding-left: 70px;
    }

    .article-content :global(ol li) {
        position: relative;
        margin-bottom: 20px;
    }

    .share {
        display: flex;
        padding-bottom: 30px;
        margin-bottom: 50px;
        border-bottom: 2px solid #4F4F4F;
    }

    .share .link {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        color: white;
        font-size: 20px;
        background: linear-gradient(205deg, rgba(151, 156, 240, 0.2) 25%, rgba(151, 156, 240, 0.2) 25%, rgba(255, 255, 255, 0.015) 93%);
        transition: .25s;
    }

    .share .link:hover {
        background: #1f2538;
    }

    .article-content :global(iframe) {
        margin: 0 auto;
        display: block;
        max-width: 100%;
    }

    @media(max-width: 1400px) {
        .article-content :global(blockquote) {
            margin: 78px 180px 50px;
        }
    }

    @media(max-width: 1199px) {
        .article-content :global(blockquote) {
            margin: 78px 100px 50px;
        }
    }

    @media(max-width: 991px) {
        .article-content {
            padding-bottom: 40px;
        }
    }

    @media(max-width: 767px) {
        .title {
            font-size: 30px;
            line-height: 39px;
            margin: 30px 0 20px;
        }

        .article-section {
            padding-top: 62px;
        }

        .article-section :global(.back) {
            margin: 30px 0;
        }

        .date {
            font-size: 14px;
            line-height: 21px;
            margin-bottom: 30px;
        }

        .article-content :global(img) {
            margin: 30px auto !important;
            float: none !important;
            height: auto;
        }

        .article-content {
            font-size: 14px;
            line-height: 21px;
        }

        .article-content :global(h2) {
            font-size: 25px;
            margin: 50px 0 20px;
        }

        .article-content :global(h3) {
            font-size: 20px;
            margin: 30px 0 20px;
        }

        .article-content :global(ul) {
            margin: 20px 0;
            padding-left: 38px;
        }

        .article-content :global(ol) {
            margin: 20px 0;
            padding-left: 38px;
        }

        .article-content :global(blockquote) {
            margin: 50px 18px 30px;
            padding: 20px 40px;
        }

        .article-content :global(blockquote:before) {
            width: 54px;
            height: 42px;
            background-size: contain;
            left: -18px;
            top: -22px;
        }

        .share .link {
            margin-right: 30px;
        }
    }
</style>
